module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "slide",
    attrs: {
      "id": "s1"
    }
  }, [_c('div', {
    staticClass: "slide",
    attrs: {
      "id": "s2"
    }
  }, [_c('div', {
    staticClass: "slide",
    attrs: {
      "id": "s3"
    }
  }, [_c('div', {
    staticClass: "slide",
    attrs: {
      "id": "s4"
    }
  }, [_c('div', {
    staticClass: "slide",
    attrs: {
      "id": "s5"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "page",
    attrs: {
      "id": "p1"
    }
  }, [_c('section', {
    staticClass: "icon"
  }, [_vm._m(1), _vm._v(" "), _c('span', {
    staticClass: "subtitle"
  }, [_vm._v("Web Developer  "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:vinayak.kulkarni@live.com"
    }
  }, [_vm._v(_vm._s(_vm.email))])])])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    attrs: {
      "id": "menu"
    }
  }, [_c('a', {
    attrs: {
      "href": "#s1"
    }
  }, [_c('li', {
    staticClass: "icon fa fa-home",
    attrs: {
      "id": "home"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#s2"
    }
  }, [_c('li', {
    staticClass: "icon fa fa-user",
    attrs: {
      "id": "user"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#s3"
    }
  }, [_c('li', {
    staticClass: "icon fa fa-code",
    attrs: {
      "id": "skill"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#s5"
    }
  }, [_c('li', {
    staticClass: "icon fa fa-gamepad",
    attrs: {
      "id": "game"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "homeTitle"
  }, [_c('img', {
    staticStyle: {
      "margin-left": "50%"
    },
    attrs: {
      "src": require("../assets/logo.png"),
      "alt": "Vinayak Logo"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "c-article__title"
  }, [_vm._v("Vinayak Kulkarni")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page",
    attrs: {
      "id": "p2"
    }
  }, [_c('section', {
    staticClass: "icon2 fa fa-user"
  }, [_c('span', {
    staticClass: "aboutTitle"
  }, [_vm._v("About Me")]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('span', [_c('i', {
    staticClass: "subicon fa fa-graduation-cap"
  }), _c('br'), _c('strong', [_vm._v("University of Pune")]), _c('br'), _vm._v("Masters in Computer Science")]), _vm._v(" "), _c('span', [_c('i', {
    staticClass: "subicon fa fa-soccer-ball-o"
  }), _c('br'), _c('strong', [_vm._v("Arsenal")]), _c('br'), _vm._v("Come on you Gooners!")]), _vm._v(" "), _c('span', [_c('i', {
    staticClass: "subicon fa fa-github"
  }), _c('br'), _c('strong', [_vm._v("GitHub")]), _c('br'), _c('a', {
    attrs: {
      "href": "https://github.com/vinayakkulkarni"
    }
  }, [_vm._v("Checkout my GitHub Profile")])]), _vm._v(" "), _c('span', [_c('i', {
    staticClass: "subicon fa fa-map-marker"
  }), _c('br'), _c('strong', [_vm._v("Bangalore, KA")]), _c('br'), _vm._v("India")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page",
    attrs: {
      "id": "p3"
    }
  }, [_c('section', {
    staticClass: "icon2 fa fa-code"
  }, [_c('span', {
    staticClass: "aboutTitle"
  }, [_vm._v("Skills")]), _vm._v(" "), _c('div', {
    staticClass: "skillblock"
  }, [_c('span', [_c('i', {
    staticClass: "subicon fa fa-globe"
  }), _c('br'), _c('strong', [_vm._v("Web Development")]), _c('br'), _vm._v("HTML, CSS\n                  "), _c('br'), _vm._v("VueJS 💕\n                  "), _c('br'), _vm._v("Semantic-UI, jQuery, Vanilla JS\n                  "), _c('br'), _vm._v("Laravel\n                  "), _c('br'), _vm._v("AngularJS, ionic\n                ")]), _vm._v(" "), _c('span', [_c('i', {
    staticClass: "subicon fa fa-laptop"
  }), _c('br'), _c('strong', [_vm._v("Software Development")]), _c('br'), _vm._v("JSON\n                ")]), _vm._v(" "), _c('span', [_c('i', {
    staticClass: "subicon fa fa-database"
  }), _c('br'), _c('strong', [_vm._v("Database Management")]), _vm._v(" "), _c('br'), _vm._v("MySQL, Oracle\n                  "), _c('br'), _vm._v("MongoDB, Firebase\n                ")]), _vm._v(" "), _c('span', [_c('i', {
    staticClass: "subicon fa fa-folder"
  }), _c('br'), _c('strong', [_vm._v("Miscellaneous")]), _c('br'), _vm._v("NPM\n                  "), _c('br'), _vm._v("Cordova, AngularJS\n                  "), _c('br'), _vm._v("Ionic, Bootstrap\n                  "), _c('br'), _vm._v("Materialize, Git\n                ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page",
    attrs: {
      "id": "p5"
    }
  }, [_c('section', {
    staticClass: "icon2 fa fa-gamepad"
  }, [_c('span', {
    staticClass: "aboutTitle"
  }, [_vm._v("Coming Soon!")]), _vm._v(" "), _c('div', {
    staticClass: "block"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-10cf2597"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Hello.vue
// module id = 10
// module chunks = 0